/* eslint-disable no-nested-ternary */
import { Badge, BADGE_VARIANTS } from 'ui/badge';
import { WorkflowType } from '../../../enums';

export const ENABLED_WORKFLOW_BADGE_ID = `badge-${BADGE_VARIANTS.RUNNING}`;
export const DISABLED_WORKFLOW_BADGE_ID = `badge-${BADGE_VARIANTS.ABORTED}`;
export const DRAFT_WORKFLOW_BADGE_ID = `badge-${BADGE_VARIANTS.DRAFT}`;

enum WORKFLOW_STATUS_TEXT {
  DRAFT = 'Draft',
  ENABLED = 'Live',
  DISABLED = 'Off',
}

type WorkflowLiveStatusBadgeProps = {
  isWorkflowEnabled: boolean;
  workflowType?: WorkflowType;
};

const isDraft = (workflowType?: WorkflowType) => workflowType === WorkflowType.DRAFT;

const getTestId = (
  isWorkflowEnabled: WorkflowLiveStatusBadgeProps['isWorkflowEnabled'],
  workflowType: WorkflowLiveStatusBadgeProps['workflowType'],
) =>
  isDraft(workflowType)
    ? DRAFT_WORKFLOW_BADGE_ID
    : isWorkflowEnabled
      ? ENABLED_WORKFLOW_BADGE_ID
      : DISABLED_WORKFLOW_BADGE_ID;

const getVariant = (
  isWorkflowEnabled: WorkflowLiveStatusBadgeProps['isWorkflowEnabled'],
  workflowType: WorkflowLiveStatusBadgeProps['workflowType'],
) =>
  isDraft(workflowType)
    ? BADGE_VARIANTS.DRAFT
    : isWorkflowEnabled
      ? BADGE_VARIANTS.RUNNING
      : BADGE_VARIANTS.ABORTED;

const getText = (
  isWorkflowEnabled: WorkflowLiveStatusBadgeProps['isWorkflowEnabled'],
  workflowType: WorkflowLiveStatusBadgeProps['workflowType'],
) =>
  isDraft(workflowType)
    ? WORKFLOW_STATUS_TEXT.DRAFT
    : isWorkflowEnabled
      ? WORKFLOW_STATUS_TEXT.ENABLED
      : WORKFLOW_STATUS_TEXT.DISABLED;

const getBadgeDetails = ({ isWorkflowEnabled, workflowType }: WorkflowLiveStatusBadgeProps) => ({
  testId: getTestId(isWorkflowEnabled, workflowType),
  variant: getVariant(isWorkflowEnabled, workflowType),
  text: getText(isWorkflowEnabled, workflowType),
});

export const WorkflowLiveStatusBadge = (props: WorkflowLiveStatusBadgeProps) => {
  const { testId, variant, text } = getBadgeDetails(props);

  return (
    <Badge data-test={testId} variant={variant}>
      {text}
    </Badge>
  );
};
